import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Tours from '../components/Tours';
import TourPreview from './tours/Preview';
import Header from './layout/Header';
import Map from './Map';
import * as toursActions from '../actions/tours';
import { Link } from 'react-router';
import * as TourActions from '../actions/tour';
import Helmet from "react-helmet";
import Translate from './layout/Translate';
import Facebook from './popups/Facebook';
import moment from 'moment';
import { browserHistory } from 'react-router';



class Navigation extends Component {

    componentDidMount() {

        this.seasons = [];

        moment.locale(this.props.lang);
        for (let number = 1; number <= 12; number++) {

            this.seasons[number] = {id: number, title: moment(new Date('2017', number-1, '1')).format('MMMM'), months: number};

            //console.log(this.monthList[number]);
        }

        let params = {
            t: this.props.location.query.type,
            d: this.props.location.query.destination,
            a: this.props.location.query.activity,
            m: this.props.location.query.season
        };

        let hasParams = false;

        if (this.props.location.query.type || this.props.location.query.season || this.props.location.query.destination || this.props.location.query.activity) {
            hasParams = true;
        }

        let obj = this.props;
        if (this.props.location.query.type) {
            this.props.types.forEach(function(type){
                if (obj.location.query.type == type.id) {
                    obj.toursActions.selectType(type);
                }
            });
        } else if (hasParams) {
            obj.toursActions.selectType({});
        } else {
            delete params.t;
        }

        if (this.props.location.query.destination) {
            this.props.destinations.forEach(function(destination){
                if (obj.location.query.destination == destination.id) {
                    obj.toursActions.selectDestination(destination);
                }
            });
        } else if (hasParams) {
            obj.toursActions.selectDestination({});
        } else {
            //  obj.toursActions.selectDestination(this.props.destination);
            delete params.d;
        }

        if (this.props.location.query.activity) {
            this.props.activities.forEach(function(activity){
                if (obj.location.query.activity == activity.id) {
                    obj.toursActions.selectActivity(activity);
                }
            });
        } else if (hasParams) {
            obj.toursActions.selectActivity({});
        } else {
            //  obj.toursActions.selectActivity(this.props.activity);
            delete params.a;
        }

        if (this.props.location.query.season) {
            this.seasons.forEach(function(season){
                if (obj.location.query.season == season.id) {
                    obj.toursActions.selectSeason(season);
                }
            });
        } else if (hasParams) {
            obj.toursActions.selectSeason({});
        } else {
            //  obj.toursActions.selectActivity(this.props.activity);
            delete params.m;
        }


        this.props.toursActions.toursSearch(Object.assign(this.props.filter, params));

    }

    componentWillMount() {


        this.props.toursActions.setMapConfig({
            showBoundedObjects: true,
            type: 'ROADMAP',
            active: false,
            fixed: true
        });

    }



    componentDidUpdate() {


    }

    componentWillUnmount() {

        this.props.toursActions.setMapConfig({
            showBoundedObjects: false,
            fixed: false,
            listByMap: false
        });

    }
    onBtnClick() {
        this.props.toursActions.fetchToursIfNeeded(1, 1)
    }


    nextTour() {
        this.props.toursActions.nextTour()
    }
    prevTour() {
        //console.log(1111)
    }

    selectTour() {
        this.props.toursActions.selectTour(this.props.list[this.props.activeTour])
    }
    selectMapPhoto(photo, i) {
        this.props.toursActions.selectMapPhoto(photo, i);
    }

    setZoom() {

        if (this.props.map.zoom > 8) {
            this.props.toursActions.setMapConfig({
                zoom: this.props.map.zoom - 3
            });
        }
    }

    selectLandmark(landmark) {
        this.props.toursActions.selectLandmark(landmark);
    }

    moreObjects(params) {
        this.props.toursActions.moreObjects(params);
    }

    toggleToursPhotos() {
        this.props.toursActions.toggleViewPhoto();
    }

    render () {
        const { list, map, translations, seo } = this.props;


        // let { tours, landmarks, photos } = boundedObjects;



        let toursLength = 0;
      /*  if (this.props.map.listByMap && !this.props.map.forceListBySearch) {
            tours.list.forEach(function(tour){
                if (!tour.hidden && !tour.is_archived) {
                    toursLength++;
                }
            });
        } else if (tours.list) { */

        let tours = {list: []};
            this.props.list.forEach(function(tour){
                if (tour && !tour.is_archived) {
                    tours.list.push(tour);
                    toursLength++;
                }
            });

       /* }  */


        //console.info('TOURS');
        //console.info(tours);
        //console.info(this.props.map.forceListBySearch);

        let hasTours = !!toursLength && map.show_tours;
        //let hasPhotos = boundedObjects.photos && boundedObjects.photos.list && !!boundedObjects.photos.list.length && map.show_photos;
        // let hasLandmarks = boundedObjects.landmarks && boundedObjects.landmarks.list && !!boundedObjects.landmarks.list.length && map.show_landmarks;

        let paramsLength = 0;

        for (let key in this.props.filter) {
            if (this.props.filter[key]) paramsLength++;
        }



        return (

            <section className="section " ref="main">
                <Helmet
                    title={(seo.title)?seo.title:translations['navigation__title']}
                />
                <div className="section__content">
                    <Header />
                    <div>



                        <div className="tours">



                            {!paramsLength && seo.h1 &&
                            <h1>{seo.h1}</h1>
                            }
                            
                            <div className="container container_tours">

                                {!paramsLength && seo.text &&
                                <div className="container__description">
                                    <div dangerouslySetInnerHTML={{__html:seo.text}}></div>
                                </div>
                                }

                                {!hasTours &&
                                <div className="tours__error">
                                    <Translate slug="destination__no-result" /> <Link to="/map" onClick={this.setZoom.bind(this)}><Translate slug="search-on-map" /></Link>
                                </div>
                                }

                                {hasTours &&
                                <div className="navigate">
                                    <div className="navigate__title">
                                        <Translate slug="destination__tours" /> <span className="navigate__count">{toursLength}</span>
                                        <div className={"navigate__show-photos " + ((this.props.showToursPhotos)?'navigate__show-photos_active':'')} onClick={this.toggleToursPhotos.bind(this)}>
                                            {!(this.props.showToursPhotos) &&
                                            <Translate slug="navigate__show-photo" />
                                            }
                                            {(this.props.showToursPhotos) &&
                                            <Translate slug="navigate__hide-photo" />
                                            }
                                        </div>
                                    </div>
                                    {tours.list.map((tour, i) =>
                                        <TourPreview key={i} tour={tour} lang={this.props.lang} showPhotos={this.props.showToursPhotos} nextTour={this.props.toursActions.nextTour} selectTour={this.props.toursActions.selectTour} />
                                    )}
                                </div>
                                }
                                {false && hasPhotos &&
                                <div className="navigate">
                                    <div className="navigate__title"><Translate slug="destination__photos" /> <span className="navigate__count">{photos.list.length}</span></div>
                                    <div className="navigate__photos">
                                        {photos.list.map((photo, i) =>
                                                <span>
                                            {(i < boundedObjects.photos.count) &&
                                            <div className="navigate__photo" onClick={this.selectMapPhoto.bind(this, photo, i)}>
                                                {photo.thumbnails.map200 &&
                                                <img src={photo.thumbnails.map200.url} />
                                                }
                                            </div>
                                            }
                                        </span>
                                        )}
                                    </div>
                                    {photos.list.length > photos.count &&
                                    <button className="navigate__more" onClick={this.moreObjects.bind(this, {type:'photos', count: 20})}>
                                        <Translate slug="destination__more" /> {(photos.list.length - photos.count > 20)?20:(photos.list.length - photos.count)}
                                    </button>
                                    }
                                </div>
                                }



                                {false && hasLandmarks &&
                                <div className="navigate">
                                    <div className="navigate__title"><Translate slug="destination__landmarks" /> <span className="navigate__count">{landmarks.list.length}</span></div>
                                    <div className="navigate__landmarks landmark">
                                        {landmarks.list.map((landmark, i) =>
                                            <span>
                                                {(i < boundedObjects.landmarks.count) &&
                                                <div className="navigate__landmark">
                                                    <h4 className="landmark__title">
                                                        <Link to={'/info/landmarks/' + landmark.slug} className="map__info" onClick={this.selectLandmark.bind(this, landmark)}>
                                                            {landmark.title}
                                                        </Link>
                                                    </h4>
                                                    <Link className="landmark__text" to={'/info/landmarks/' + landmark.slug} onClick={this.selectLandmark.bind(this, landmark)}>
                                                        {landmark.content}
                                                    </Link>
                                                </div>
                                                }
                                            </span>
                                        )}
                                    </div>

                                    {landmarks.list.length > landmarks.count &&
                                    <button className="navigate__more" onClick={this.moreObjects.bind(this, {type:'landmarks', count: 6})}>
                                        <Translate slug="destination__more" /> {(landmarks.list.length - landmarks.count > 6)?6:(landmarks.list.length - landmarks.count)}
                                    </button>
                                    }
                                </div>
                                }
                            </div>

                            <div className="container__description">
                            </div>
                        </div>
                    </div>
                </div>

                <Facebook blockClass={"facebook_destination"} />
                <div className="footer__registration">
                    <Translate
                        slug="main__registration"/>
                </div>
            </section>
        );
    }
}


Navigation.need = [
    {
        action: toursActions.toursSearch
    }
];



function mapStateToProps(state) {
    //console.info(state);
    let { tours, postsByTour } = state;
    tours = tours;


    return {
        mapHeight: state.tours.mapHeight,
        map: state.tours.map,
        showToursPhotos: state.tours.showToursPhotos,
        lang: state.user.lang,
        list: state.tours.list,
        destinations: state.tours.destinations,
        activities: state.tours.activities,
        filter: state.tours.mapFilterParams,
        types: state.tours.types,
        type: state.tours.type,
        season: state.tours.season,
        destination: state.tours.destination,
        activity: state.tours.activity,
        seo: state.user.seo,
        translations: state.user.translations
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Navigation)





// WEBPACK FOOTER //
// ./src/common/components/Navigation.js